import React, { useMemo, useState } from 'react';
import { FileAddOutlined } from '@ant-design/icons';
import { Modal, Progress } from 'antd';

import { removeHTMLScript } from '@laigu/utils/removeHTMLTag';
import filterBlackList from '@laigu/utils/filterBlackList';

import MyIcon from '../my-icon';

import style from './index.less';

const MessageVideo = props => {
  const [visible, setVisible] = useState(false);
  const { data = {} } = props;
  const { mediaUrl, thumbUrl, fileStatus, progress, fileName } = data;

  const safeMediaUrl = filterBlackList(removeHTMLScript(mediaUrl));
  const safeThumbUrl = filterBlackList(removeHTMLScript(thumbUrl));
  const picStyle = {
    backgroundImage: `url("${safeThumbUrl}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  };

  const status = useMemo(() => {
    let status = '';
    if (fileStatus === 'uploading') {
      status = 'active';
    }
    if (fileStatus === 'error') {
      status = 'exception';
    }
    return status;
  }, [fileStatus]);

  return (
    <div>
      {fileStatus === 'success' ? (
        <div className={style.videoContainer} style={picStyle} onClick={() => setVisible(true)}>
          <MyIcon type='ecoboost-iconfontplay-circle' />
        </div>
      ) : (
        <ul className={style['msg-upload']}>
          <li className={style['msg-upload-icon']}>
            <FileAddOutlined />
          </li>
          <li className={style['msg-upload-progress']}>
            <p className={style['file-name']} title={fileName}>
              {fileName}
            </p>
            <div>
              <Progress percent={progress} size='small' status={status} />
            </div>
          </li>
        </ul>
      )}
      <Modal
        width={850}
        bodyStyle={{ maxHeight: '600px', display: 'flex', justifyContent: 'center', alignItems: 'stretch' }}
        footer={false}
        destroyOnClose={true}
        open={visible}
        onCancel={() => setVisible(false)}
      >
        <video controls autoPlay className={style.videoWrapper}>
          <source src={safeMediaUrl} type='video/mp4' />
          <source src={safeMediaUrl} type='video/quicktime' />
          <track kind='captions' />
          {'浏览器不支持该视频编码格式，请右键下载后查看'}
        </video>
      </Modal>
    </div>
  );
};

export default MessageVideo;
